import * as Yup from "yup";

const ValidationSchema = Yup.object().shape({
  username: Yup.string()
    .email('El usuario ingresado es inválido.')
    .required('El usuario es requerido.'),
  password: Yup.string()
    .min(4, 'Contraseña muy corta')
    // .max(50, 'Too Long!')
    .required('La contraseña es requerida'),
});

export default ValidationSchema;